module.exports = __webpack_public_path__ + "static/media/3 02 Tulleord Sgo.9c171f93.mp3";